import React from 'react'
import { DarkSection, Container } from '../../../components'
import { Card } from './page-header-card'
import auth from '../../../utils/auth'
import { useSelector } from 'react-redux'

const PageHeader = ({embed}) => {
  const { isOfficial, isVerified } = auth()
  const { background_color } = useSelector(state => state.organization.data)

  return (
    <DarkSection color={background_color}>
      <Container className={`${embed ? '' : 'page-header'} py-8 lg:py-20 ${isOfficial ? 'official' : isVerified ? 'verified' : ''}`}>
        <Card />
      </Container>
    </DarkSection>
  )
}

export { PageHeader }
